import styled from 'styled-components';
import { Draggable } from 'react-smooth-dnd';
import { IconButton, ListItemText } from '@mui/material';

import colors from '../../../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  width: 100%;
  text-align: center;
  padding: 20px;
`;

const StyledDraggable = styled(Draggable)`
  background: ${colors.base.gamma};
  border-radius: 5px;
  margin-bottom: 5px;
  border: ${colors.shades.gamma5} solid;
`;

const StyledListItemText = styled(ListItemText)`
  text-decoration: ${({ $isHidden, $isEditing }) => (($isHidden && !$isEditing) ? 'line-through' : 'none')};
`;

const StyledIconButton = styled(IconButton)`
  width: 32px;
  height: 32px;
  margin-right: 4px !important;
  color: ${colors.shades.gamma10} !important;
  border: 1px solid ${({ $isEditing }) => ($isEditing ? colors.shades.gamma3 : 'transparent')} !important;
  border-radius: 6px !important;
  cursor: ${({ $isEditing }) => ($isEditing ? 'pointer' : 'default')} !important;

  &:hover {
    background: ${({ $isEditing }) => ($isEditing ? colors.base.gamma : 'transparent')} !important;
  }
`;

export {
  Container,
  StyledDraggable,
  StyledListItemText,
  StyledIconButton,
};
